module.exports = __webpack_public_path__ + "img/sc-read.ce46c4a3.png";